import { Component, Injectable, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'

import { CookieService } from 'app/services/cookie.service';
import { ConstantsService } from 'app/services/constants-service';

@Injectable()
/**
 * Shared service class to provide source URL and login status.
 */
export class GlobalValuesService {
    public gblLegalStructureSelectedIDValue: any;

    constructor(
        private domSanitizer: DomSanitizer,
        private cookieService: CookieService,
    ) { }

    @Output() iframeSourceUrl: EventEmitter<any> = new EventEmitter();
    @Output() login: EventEmitter<boolean> = new EventEmitter();

    // Set Page Source Event
    setPageSourceUrl(iframeUrl: string): any {
        this.iframeSourceUrl.emit(iframeUrl);
    }

    // Get Page Source Event
    getPageSourceUrl() {
        return this.iframeSourceUrl;
    }

    setIsLoggedIn(isLoggedIn: boolean): any {
        this.login.emit(isLoggedIn);
    }

    getIsLoggedIn() {
        return this.login;
    }

}



// WEBPACK FOOTER //
// ./src/app/services/global-values.service.ts